import React from 'react';

import { useLocale } from 'state/intl';

import { StyledSodiumFlag } from './nutrition-information.styled';

const SodiumFlag = () => {
  const { region } = useLocale();

  if (region !== 'US') {
    return null;
  }

  return <StyledSodiumFlag data-testid="sodium-flag" />;
};

export default SodiumFlag;
